import React from "react";
import whyImage from "../assets/why-choose-us.png";
import { Link } from "react-router-dom";

const reasons = [
  { title: "Engineering-Grade Expertise",    desc: "Every project is guided by real engineering knowledge and field experience." },
  { title: "Multi-Brand HVAC Solutions",     desc: "We supply and install trusted global brands suited to your project and budget." },
  { title: "Complete HVAC Services",         desc: "From design and supply to installation and maintenance." },
  { title: "Fast Technical Response",        desc: "Agile on-call service across Kampala when systems need attention." },
  { title: "Long-Term Client Partnerships",  desc: "Preventive maintenance and ongoing technical support you can rely on." },
];

export default function WhyChooseUs() {
  return (
    <section className="py-10 sm:py-16 font-poppins">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">

        {/* Title */}
        <div className="flex justify-center mb-8 sm:mb-10">
          <h2
            className="text-xl sm:text-4xl rounded-md font-extrabold text-white px-8 sm:px-12 py-3 tracking-widest"
            style={{ backgroundColor: "#0F1030", border: "2px" }}
          >
            WHY CHOOSE US
          </h2>
        </div>

        <div
          className="grid grid-cols-1 lg:grid-cols-2 overflow-hidden"
          style={{ border: "2px solid white", backgroundColor: "#0F1030" }}
        >
          {/* Left — reasons */}
          <div className="p-5 sm:p-8 space-y-5 sm:space-y-6">
            {reasons.map((r) => (
              <div key={r.title} className="flex items-start gap-3 sm:gap-4">
                <div
                  className="flex-shrink-0 w-8 h-8 sm:w-9 sm:h-9 rounded-full flex items-center justify-center mt-1"
                  style={{ backgroundColor: "#00C7EF" }}
                >
                  <svg className="w-4 h-4" fill="none" stroke="white" strokeWidth="3" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div>
                  <p className="font-bold text-sm sm:text-base text-white">{r.title}</p>
                  <p className="text-gray-300 text-xs sm:text-sm mt-0.5">{r.desc}</p>
                </div>
              </div>
            ))}

            {/* Reach Out button */}
            <div className="pt-2">
              <Link
                to="/contact"
                className="inline-block text-xs sm:text-sm font-bold tracking-wide px-6 py-2.5"
                style={{ backgroundColor: "#00C7EF", color: "#0F1030" }}
                onMouseEnter={e => { e.currentTarget.style.backgroundColor = "#ffffff"; e.currentTarget.style.color = "#0F1030"; }}
                onMouseLeave={e => { e.currentTarget.style.backgroundColor = "#00C7EF"; e.currentTarget.style.color = "#0F1030"; }}
              >
                REACH OUT
              </Link>
            </div>
          </div>

          {/* Right — image stretches to full left panel height */}
          <div className="hidden lg:block overflow-hidden h-[500px]">
            <img
              src={whyImage}
              alt="Why Choose SmartCool"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}